// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1nMpi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Q31t"};